import { useMutation } from "@tanstack/react-query";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../constants/firebaseModular";
import { UpdateFileRefPayload } from "../types/Chart/UpdateFileRefPayload";
import { Chart } from "../types/Chart/Chart";

const updateFileReference = async (payload: UpdateFileRefPayload) => {
  const docTitle = Object.keys(payload)[0] as keyof Chart;
  const docRef = doc(
    db,
    "users",
    payload[docTitle].patientId,
    "Chart",
    docTitle,
  );
  const data = payload[docTitle];

  await setDoc(docRef, data.docData, { merge: true });
};

export const useUpdateFileReference = () => {
  return useMutation({
    mutationFn: (payload: UpdateFileRefPayload) => updateFileReference(payload),
  });
};
